import React, { useState } from "react";
import SingleRegistrationForm from "./SingleRegistrationForm";
import CenteredHeading from "../../../../components/UI/headingsUI/CenteredHeading";
import BulkRegistrationForm from "./BulkRegistrationForm";
import FormTabSwitcher from "../../../../components/UI/FormTabSwitcher";

const tabs = [
  { name: "single", label: "Single Cylinder Registration" },
  { name: "bulk", label: "Bulk Cylinder Registration" },
];

const RegistrationContainer = () => {
  const [currentTab, setCurrentTab] = useState("single");

  return (
    <div className="form-container">
      <CenteredHeading title="Cylinder Registration" />
      <div className="cylinder-tab-container">
        <FormTabSwitcher
          tabs={tabs}
          currentTab={currentTab}
          onTabChange={(tabName) => setCurrentTab(tabName)}
        />
        <div className="p-1 sm:p-4">
          {currentTab === "single" && <SingleRegistrationForm />}
          {currentTab === "bulk" && <BulkRegistrationForm />}
        </div>
      </div>
    </div>
  );
};

export default RegistrationContainer;
